import { Component, Story, Knobs } from './DocTypes';

const knobs: Knobs = {
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
};

const editorKnobs: Knobs = {
  width: {
    default: '200px',
    editor: 'textbox',
  },
  height: {
    default: '20px',
    editor: 'textbox',
  },
  borderRadius: {
    default: '',
    editor: 'textbox',
  },
};

const BasicStory: Story = {
  title: 'Basic',
  description: 'A basic skeleton',

  coreComponent_v3: {
    html: `<div style="padding: 16px;">
  <tag3-skeleton {{...knobs}}></tag3-skeleton>
</div>`,
    knobs: {
      ...knobs,
      ...editorKnobs,
      itemStyle: {
        editor: 'textbox',
        default: '',
      },
    },
  },
  reactWrapper_v3: {
    jsx: `<div style={{padding: "16px" }}>
  <TagSkeleton {{...knobs}}> </TagSkeleton>
</div>`,
    knobs: {
      ...knobs,
      ...editorKnobs,
      itemStyle: {
        editor: 'textbox',
        default: '',
        qualifierStart: '{',
        qualifierEnd: '}',
      },
    },
  },
};

const MultipleStory: Story = {
  title: 'Multiple',
  description: 'A basic skeleton',

  coreComponent_v3: {
    html: `<div style="display: flex; width: 343px; padding: 16px;">
  <tag3-skeleton height="40px" width="40px" border-radius="50%"></tag3-skeleton>
  <div style="flex: 1 1 auto; margin-left: 16px;">
    <tag3-skeleton height="20px" width="100%" item-style='{"margin-bottom": "10px"}'></tag3-skeleton>
    <tag3-skeleton height="14px" width="100%" item-style='{"margin-bottom": "10px"}'></tag3-skeleton>
    <tag3-skeleton height="14px" width="100%"></tag3-skeleton>
  </div>
</div>`,
    knobs: { ...knobs },
  },
  reactWrapper_v3: {
    jsx: `<div style={{ "display": "flex", "width": "343px", padding: "16px" }}>
  <TagSkeleton height="40px" width="40px" borderRadius="50%"></TagSkeleton>
  <div style={{ "flex": "1 1 auto", "marginLeft": "16px"}}>
    <TagSkeleton height="20px" width="100%" itemStyle={{"margin-bottom": "10px"}}></TagSkeleton>
    <TagSkeleton height="14px" width="100%" itemStyle={{"margin-bottom": "10px"}}></TagSkeleton>
    <TagSkeleton height="14px" width="100%"></TagSkeleton>
  </div>
</div>`,
    knobs: {
      ...knobs,
    },
  },
};

export const TagSkeletonDocs: Component = {
  type: 'component',
  name: 'skeleton',
  description: 'Renders a skeleton',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'colourScheme',
      description:
        'Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'width',
      description: 'The width of the skeleton element',
      type: 'string',
    },
    {
      name: 'height',
      description: 'The height of the skeleton element',
      type: 'string',
    },
    {
      name: 'borderRadius',
      description: 'The border-radius of the skeleton element',
      type: 'string',
    },
    {
      name: 'itemStyle',
      description: 'JSX style object in JSON to apply to the skeleton',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [BasicStory, MultipleStory],
};
